import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentTeam } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/IncidentTeam';
import {
  ListUserResourceForMenuResponse
} from 'it/primatoo/openapi/api/org/schemas/userresource/ListUserResourceForMenuResponse';
import {
  UpdateIncidentTeamRequest
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/UpdateIncidentTeamRequest';
import {
  Resource as ListUserResource
} from 'it/primatoo/openapi/api/org/schemas/userresource/listuserresourceformenuresponse/Resource';
import {
  Resource as UpdateRequestResource
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/updateincidentteamrequest/Resource';
import {
  Resource as IncidentTeamResource
} from 'it/primatoo/openapi/api/org/schemas/databreachprocess/incidentteam/Resource';
import { InputUserChooserData } from '../documents/components/input-user-chooser/input-user-chooser-data';

@Component({
  selector: 'pt-incident-team-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ 'TITLE.INCIDENT_TEAM' | translate }}
      </h4>
    </div>
    <div class='modal-body'>
      <form [formGroup]='formGroup' *ngIf="formGroup">
        <pt-input-user-chooser
          [label]="'LABELS.RESOURCES' | translate"
          [controlName]='"users"'
          [options]="inputUserChooserOptions"
          formControlName='users'
        ></pt-input-user-chooser>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid || formGroup.pristine'
              (click)='confirm()'>
        {{ 'BUTTON.SAVE' | translate }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false)'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class IncidentTeamDialogComponent {
  menu: ListUserResourceForMenuResponse;
  incidentTeam: IncidentTeam;
  formGroup: FormGroup;
  inputUserChooserOptions: InputUserChooserData<ListUserResource>;

  constructor(public activeModal: NgbActiveModal) {
  }

  confirm() {
    const val: IncidentTeamResource[] = this.formGroup.controls.users.value;
    const request: UpdateIncidentTeamRequest = {
      resources: val.map((m) => {
        return {
          resourceId: m.id,
          role: m.role
        } as UpdateRequestResource
      })
    };
    this.activeModal.close(request);
  }

  run(menu: ListUserResourceForMenuResponse, incidentTeam: IncidentTeam) {
    this.menu = menu;
    this.incidentTeam = incidentTeam;
    this.formGroup = new FormGroup({
      users: new FormControl(null, [Validators.required])
    });


    this.inputUserChooserOptions = {
      bindLabel: 'fullName',
      bindValue: 'id',
      items: this.menu.resources
    }
    this.formGroup.controls.users.setValue(this.incidentTeam.resources);
  }
}
